/**
 * Icon mapping services
 */
export const iconService = {
  getIconByCategory,
  getCategorySlug
};

// Available icons
const icons = {
  'appliances-large': {
    icon: 'icons8-appliances-50.png',
    name: 'Appliances - Large'
  },
  'appliances-small': {
    icon: 'icons8-blender-50.png',
    name: 'Appliances - Small'
  },
  'artwork': {
    icon: 'icons8-easel-50.png',
    name: 'Artwork'
  },
  'books': {
    icon: 'icons8-books-100.png',
    name: 'Books'
  },
  'cleaning-maintenance': {
    icon: 'icons8-housekeeping-32.png',
    name: 'Cleaning & Maintenance'
  },
  'clothing-childrens': {
    icon: 'icons8-clothes-25.png',
    name: 'Clothing - Childrens'
  },
  'clothing-mens': {
    icon: 'icons8-formal-outfit-50.png',
    name: 'Clothing - Mens'
  },
  'clothing-womens': {
    icon: 'icons8-dress-front-view-50.png',
    name: 'Clothing - Women'
  },
  'collectibles': {
    icon: 'icons8-collectibles-50.png',
    name: 'Collectibles'
  },
  'dinnerware': {
    icon: 'icons8-dish-91.png',
    name: 'Dinnerware'
  },
  'electronics': {
    icon: 'icons8-hdtv-80.png',
    name: 'Electronics'
  },
  'furniture': {
    icon: 'icons8-sofa-50.png',
    name: 'Furniture'
  },
  'handbags-luggage': {
    icon: 'icons8-handbag-50.png',
    name: 'Handbags & Luggage'
  },
  'health-beauty': {
    icon: 'icons8-hair-dryer-50.png',
    name: 'Health & Beauty'
  },
  'health-fitness': {
    icon: 'icons8-bench-press-50.png',
    name: 'Health & Fitness Equipment'
  },
  'home-decor': {
    icon: 'icons8-home-decoration-66.png',
    name: 'Home Décor'
  },
  'jewelry': {
    icon: 'icons8-jewelry-32.png',
    name: 'Jewelry'
  },
  'lawn-equipment': {
    icon: 'icons8-lawn-mower-64.png',
    name: 'Lawn Equipment'
  },
  'lighting-fixtures': {
    icon: 'icons8-chandelier-80.png',
    name: 'Lighting Fixtures'
  },
  'linens-bedding': {
    icon: 'icons8-bed-50.png',
    name: 'Linens & Bedding'
  },
  'medical-supplies': {
    icon: 'icons8-wheelchair-64.png',
    name: 'Medical Supplies'
  },
  'musical-instruments': {
    icon: 'icons8-guitar-64.png',
    name: 'Musical Instruments'
  },
  'office-supplies': {
    icon: 'icons8-office-50.png',
    name: 'Office Supplies'
  },
  'outdoor-gear': {
    icon: 'icons8-camping-tent-16.png',
    name: 'Outdoor Gear'
  },
  'pet-products': {
    icon: 'icons8-pet-bowl-64.png',
    name: 'Pet Products'
  },
  'shoes': {
    icon: 'icons8-women-shoe-100.png',
    name: 'Shoes'
  },
  'sporting-goods': {
    icon: 'icons8-golf-clubs-50.png',
    name: 'Sporting Goods'
  },
  'tools-hardware': {
    icon: 'icons8-drill-64.png',
    name: 'Tools & Hardware'
  },
  'miscellaneous': {
    icon: 'icons8-camera-addon-identification-50.png',
    name: 'Miscellaneous'
  },
  'null-icon': {
    icon: 'icons8-camera-addon-identification-50.png',
    name: 'Not Found'
  }
}

function getIconByCategory(id) {
  if (icons[id]) return icons[id];
  else return icons['null-icon'];
}

/**
 * Format category name for url inclusion
 */
function getCategorySlug(category) {
  // to lowercase
  category = category.toLowerCase();
  // remove punctuation chars
  category = category.replace(/[']/g, '');
  // Remove non alphabetical chars
  category = category.replace(/[^a-z]+/g, '-');
  
  return category;
}
